var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M19.8555 13H13.8555V19H11.8555V13H5.85547V11H11.8555V5H13.8555V11H19.8555V13Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
